module.exports = __webpack_public_path__ + "img/benefit_time.2174f1ad.png";